module.exports = __webpack_public_path__ + "img/ico_publishing.58f26248.svg";